import styled from "styled-components";
import { layout } from "styled-system";

const Mask = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.45);
  filter: alpha(opacity=50);
`;

const Wrapper = styled.div`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  overflow: auto;
  outline: 0;
  -webkit-overflow-scrolling: touch;
`;

const Container = styled.div`
  ${layout}/* @media only screen and (max-width: 767px) {
    padding-right: 0;
    padding-left: 0;
    margin: 0;
  } */
`;

const Header = styled.div`
  display: flex;
  padding-right: 40px;
  padding-left: 40px;
  width: 100%;
  height: 90px;
  min-height: 90px;
  align-items: center;
  justify-content: space-between;
  height: 80px;
  padding-left: 30px;
  padding-right: 30px;
  background: #f7f7f7;
  border-radius: 10px 10px 0 0;
  h2 {
    margin-top: 0;
    margin-bottom: 0;
    color: #21219a;
    letter-spacing: -1px;
    font-weight: 700;
    font-size: 22px;
    line-height: 20px;
  }
  @media only screen and (max-width: 767px) {
  }
`;

const Footer = styled.div`
  padding: 20px 30px;
  padding-bottom: 30px;
`;

const Body = styled.div`
  /* padding: 20px 30px; */
`;

const DialogBox = styled.div``;

const Closer = styled.button`
  background: transparent;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  display: none;
  &:focus {
    outline: none;
  }
  > i {
    display: block;
    width: 13px;
    height: 13px;
    border: solid;
    border-width: 0 0 1px 1px;
    border-color: #b0b0b0;
    position: absolute;
    left: 10px;
    top: 50%;
    transform: translateY(-50%) rotate(45deg);
  }
  @media only screen and (max-width: 767px) {
    display: block;
    height: 80px;
    width: 200px;
    background: transparent;
  }
`;

export { Mask, Wrapper, Container, Header, Footer, Body, DialogBox, Closer };
